import { config } from "@/utils/configuration/config";
import RangesForTypeRepoStatic from "@/repositories/rangesForType/RangesForTypeRepoStatic";
import RangesForTypeRepoFirebase from "@/repositories/rangesForType/RangesForTypeRepoFirebase";

var Singleton = (function () {
  var repo = null;
  var rangesForType = new Map();

  function createInstance(ref) {
    if (repo == null) {
      // Se obtiene el valor de la configuración para saber si hay que utilizar firebase o se
      // van a utilizar datos estáticos de prueba
      if (!config.app.useFirebase) {
        repo = new RangesForTypeRepoStatic();
      } else {
        repo = new RangesForTypeRepoFirebase();
      }
    }

    if (!rangesForType.has(ref)) {
      rangesForType.set(ref, []);
      //console.log("RangesForTypeService - Vamos al repo a buscar los rangos del tipo el tipo", ref);
      repo.getRangesForTypeShipType(ref, foundRangesCallback);
    }

    return rangesForType.get(ref);
  }

  function foundRangesCallback(ref, typeElement) {
    const rangesForTypeActual = rangesForType.get(ref);
    rangesForTypeActual.push(typeElement);
    rangesForType.set(ref, rangesForTypeActual);
  }

  return {
    getRangesForType: function (ref) {
      // console.log("RangesForTypeService - getRangesForType")
      return createInstance(ref);
    },
  };
})();

export default Singleton;
